import styled from 'styled-components';

// CONSTANTS
import { theme } from '../../constants/theme';

// INTERFACES
import { ITable } from '../../interfaces/Table.interface';

export const Table = styled.table`
  display: table;
  width: 100%;
  position: relative;
  border: 1px solid ${theme.colors.primary.transparentBorder};
  border-top: none;
  border-bottom: none;
  font-size: 11px;
  color: ${theme.colors.secondary.gray300};
  background: ${theme.colors.primary.white};
  flex: 1;
  border-spacing: 0;
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.semibold};
`;

export const Thead = styled.thead`
  display: table-header-group;
`;

export const Tbody = styled.tbody``;

export const Th = styled.th`
  width: 20%;
  position: relative;
  display: table-cell;
  border-bottom: 1px solid ${theme.colors.primary.transparentBorder};
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.semibold};
  font-size: 11px;
  text-align: left;
  color: ${theme.colors.secondary.gray300};

  > label {
    cursor: pointer;
    position: relative;
    &:after {
      display: block;
      position: absolute;
      right: -16px;
      top: 0;
    }
  }
`;

export const Tr = styled.tr<ITable>`
  ${({ cursor }) => cursor && `cursor: pointer`}
`;

export const Td = styled.td`
  padding: 13px 0;
  border-bottom: 1px solid ${theme.colors.primary.transparentBorder};
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.regular};
  font-size: 13px;
  line-height: 16px;
  font-weight: 500;
  color: ${theme.colors.secondary.gray300};
  text-transform: capitalize;
`;
